<template>
  <div class="overflow-x-auto">
    <table class="min-w-full divide-y divide-gray-200">
      <thead class="bg-gray-50">
        <tr>
          <th class="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider">
            Titre
          </th>
          <th class="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider">
            Quantité
          </th>
          <th class="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider">
            Action
          </th>
        </tr>
      </thead>
      <tbody class="bg-white divide-y divide-gray-200">
        <template v-for="(pkg, index) in packages" :key="pkg.id">
          <!-- En-tête de section : Taille paquet (seulement si c'est le premier ou si le nombre de tailles change) -->
          <tr v-if="index === 0 || pkg.nombreTailles !== packages[index - 1].nombreTailles" class="bg-gray-50">
            <td colspan="3" class="px-6 py-3 text-sm font-semibold text-black">
              <slot name="section-header" :item="pkg">
                Taille paquet : {{ pkg.nombreTailles }}
              </slot>
            </td>
          </tr>
          
          <!-- Ligne de données du paquet -->
          <tr class="hover:bg-gray-50">
            <!-- Titre -->
            <td class="px-6 py-4 whitespace-nowrap">
              <slot name="titre" :item="pkg">
                <div class="px-3 py-2 text-sm text-black bg-gray-50 rounded-md border border-gray-200">
                  {{ pkg.titre }}
                </div>
              </slot>
            </td>
            
            <!-- Quantités (uniquement les valeurs non nulles) -->
            <td class="px-6 py-4">
              <slot name="quantites" :item="pkg">
                <div class="flex gap-1 flex-wrap">
                  <div 
                    v-for="(quantite, index) in pkg.quantites" 
                    :key="index"
                    class="px-3 py-1.5 text-sm text-center text-white bg-blue-600 rounded font-medium"
                  >
                    {{ quantite }}
                  </div>
                </div>
              </slot>
            </td>
            
            <!-- Action -->
            <td class="px-6 py-4 whitespace-nowrap text-sm text-black">
              <slot name="action" :item="pkg">
                <div class="flex gap-2">
                  <button
                    @click="$emit('edit', pkg.id)"
                    class="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
                  >
                    <i class="fas fa-edit mr-1"></i>
                    Modifier
                  </button>
                  <button
                    @click="$emit('delete', pkg.id)"
                    class="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors"
                  >
                    <i class="fas fa-trash mr-1"></i>
                    Supprimer
                  </button>
                </div>
              </slot>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import type { PackageItem } from '@/types/pack'

interface Props {
  packages: PackageItem[]
}

interface Emits {
  (e: 'edit', packageId: number): void
  (e: 'delete', packageId: number): void
}

defineProps<Props>()
defineEmits<Emits>()
</script>
